import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { CoreLayoutMainModule, LayoutComponent } from '@auto-editor/core/layout/main';
import { AuthGuard } from '@auto-editor/guards';

const routes: Route[] = [
  {
    path: 'auth',
    loadChildren: () => import('@auto-editor/feature-auth').then((m) => m.CoreFeatureAuthModule)
  },
  {
    path: 'errors',
    loadChildren: () => import('@auto-editor/core/errors/feature-error-pages').then((m) => m.CoreErrorsFeatureErrorPagesModule)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('@auto-editor/dashboard').then((module) => module.DashboardModule)
      },
      {
        path: 'questionnaire/:qnId/editor',
        loadChildren: () => import('@auto-editor/editor').then((m) => m.EditorModule),
        data: {
          breadcrumbs: [
            {
              label: 'Nombre de la encuesta',
              url: '/'
            },
            {
              label: 'Edición',
              url: '/'
            }
          ]
        }
      },
      {
        path: 'questionnaire/:qnId/share',
        loadChildren: () => import('@auto-editor/share').then((m) => m.ShareModule),
        data: {
          breadcrumbs: [
            {
              label: 'Nombre de la encuesta',
              url: '/'
            },
            {
              label: 'Share',
              url: '/'
            }
          ]
        }
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [
    HttpClientModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always'
    }),
    CoreLayoutMainModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
